export default __webpack_public_path__ + "static/media/select-arrow.79415416.svg";